import { useSelector } from 'react-redux'

export default function useMobileClients(filterFunction = i => true) {
  const mobileClients = useSelector((state) => state.userService.mobileClients);
  return mobileClients?.filter(filterFunction);
}
